import styled from 'styled-components';
import { animated } from 'react-spring';

export const Container = styled(animated.div)`
  width: 100%;
  max-width: 60rem;
  padding: 0 2.5rem;
  margin: 0 auto;

  &.padding-top {
    padding-top: 6.25rem;
  }
  &.padding-bottom {
    padding-bottom: 3.125rem;
  }

  @media all and (max-width: 960px) {
    padding: 0 1.25rem;

    &.padding-top {
      padding-top: 3.125rem;
    }
  }
`;
